module.exports = __webpack_public_path__ + "img/image_34.a62731c5.png";